import { ReactComponent } from "./btn_delete.svg";

import styled from "styled-components";

const StyledIcon = styled(ReactComponent)`
  cursor: pointer;
`;

const DeleteIcon = () => <StyledIcon />;

export default DeleteIcon;
